import React from 'react';
import { useDisposition } from '../../../context/disposition/DispositionContext';
import { Modal } from 'floorplan/components/v2/Modal';
import { Button } from 'floorplan/components/Button';
import { closeModal, openModal } from '@offerpad/concrete.react/lib/Modal';
import { useModal } from '@offerpad/concrete.react/lib/Modal';
import { Modals } from '../../Controls/ModalController/ModalController';
import useScreen from '@offerpad/floorplan/dist/hooks/useScreen';
import { modalWidth } from '../common/constants';
import { Breakpoints } from '../../../utils/breakpointUtil';
import styles from '../common/OfferActionModal.module.scss';

const WidthdrawOfferModal: React.FC = () => {
    const { state: { isOpen }, dispatch: modalDispatch } = useModal();
    const screen = useScreen();

    const { state: { dispositionOffer: { id }, loading, error, exception },
        declineOffer, clearError } = useDisposition();

    const closeModalWrapper = () => {
        clearError();
        closeModal(modalDispatch);
    }

    return <Modal
        open={isOpen}
        onClose={() => closeModalWrapper()}
        hasFooter
        width={screen.width < Breakpoints.DESKTOP ? modalWidth : null}
    >
        <Modal.Header
            title='Withdraw Offer'
            onClose={() => closeModalWrapper()}
            border
        />
        <Modal.Content>
            {error && <div className={styles.error}>
                {exception?.response?.data?.message || 'Error something went wrong, try again'}
            </div>}
            <div className={styles.modal_content}>
                Are you sure you want to withdraw from this offer? You will not be able to undo this action.
            </div>
        </Modal.Content>
        <Modal.Footer border>
            <Button
                id='cancel-widthdraw-offer'
                secondary
                type="submit"
                className="modal-new-cancel-button"
                onClick={() => closeModalWrapper()}
            >
                Cancel
            </Button>
            <Button
                id="button-060220220907"
                brand
                type="submit"
                className="modal-new-action-button"
                progress={loading}
                onClick={() => declineOffer(id).then((success) => success ?
                    openModal(modalDispatch, Modals.WITHDRAWED_OFFER_MODAL)
                    :
                    null
                )}
            >
                Withdraw Offer
            </Button>
        </Modal.Footer>
    </Modal>
}

export default WidthdrawOfferModal;